import React from 'react';

import { usePaths } from '../hooks/usePaths';

import Svg from './Svg';
import Button from './Button';

export default function ConvelioLogo({
  color = 'black',
  additionalClassNames = ''
}) {
  const { getHomepagePath } = usePaths();
  const convelioLogo = `convelio-logo-${
    color === 'white' ? 'white' : color === 'blue' ? 'blue' : 'black'
  }`;

  return (
    <>
      <div className={`convelio-logo --${color} ${additionalClassNames}`}>
        <Button
          button={{
            version: 'wrapper',
            ariaLabel: 'Convelio Logo',
            page: getHomepagePath()
          }}
        >
          <Svg svg={convelioLogo} />
        </Button>
      </div>
    </>
  );
}
